
import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { VirtualTeamMember } from "../types";

interface VirtualTeamDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (memberData: Omit<VirtualTeamMember, 'id'>) => void;
  editingMember: VirtualTeamMember | null;
}

export const VirtualTeamDialog = ({ isOpen, onClose, onSave, editingMember }: VirtualTeamDialogProps) => {
  const [formData, setFormData] = useState({
    title: '',
    name: '',
    activity: '',
    expected_completion_date: '',
    status: ''
  });

  useEffect(() => {
    if (editingMember) {
      setFormData({
        title: editingMember.title || '',
        name: editingMember.name || '',
        activity: editingMember.activity || '',
        expected_completion_date: editingMember.expected_completion_date ? 
          new Date(editingMember.expected_completion_date).toISOString().split('T')[0] : '',
        status: editingMember.status || ''
      });
    } else {
      setFormData({
        title: '',
        name: '',
        activity: '',
        expected_completion_date: '',
        status: ''
      });
    }
  }, [editingMember, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-white text-black">
        <DialogHeader>
          <DialogTitle>{editingMember ? 'Edit Team Member' : 'Add New Team Member'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="title">Title</Label>
            <Input
              id="title"
              className="bg-white text-black"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              className="bg-white text-black"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="activity">Activity</Label>
            <Input
              id="activity"
              className="bg-white text-black"
              value={formData.activity}
              onChange={(e) => setFormData({...formData, activity: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="expected_completion_date">Expected Completion Date</Label>
            <Input
              id="expected_completion_date"
              className="bg-white text-black"
              type="date"
              value={formData.expected_completion_date}
              onChange={(e) => setFormData({...formData, expected_completion_date: e.target.value})}
            />
          </div>
          <div>
            <Label htmlFor="status">Status</Label>
            <Input
              id="status"
              className="bg-white text-black"
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
              required
            />
          </div>
          <Button type="submit" className="w-full">
            {editingMember ? 'Update' : 'Add'} Team Member
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
